<template>
  <div class="container" :class="{ 'u-pop': isPopup }">
    <div class="wrap-c">
      <div class="list-wrap" v-if="listWithoutKeywords.length">
        <div class="tj-ui">为您推荐附近以下自提点</div>
        <input
          class="keywords"
          type="text"
          placeholder="输入关键词快速查找"
          v-model="keywords"
          @input="onInput"
          maxlength="20"
        />
        <div v-infinite-scroll="loadMore" infinite-scroll-distance="60">
          <address-item
            v-for="(item, index) in list"
            :key="index"
            :item="item"
            :selectedId="selectedId"
            v-show="index < lastShowNum"
            @modifyDefault="reloadList"
            @removeItem="reloadList"
            @clkBody="useAddress(item)"
          >
          </address-item>
        </div>
      </div>

      <div class="empty" v-if="!list.length && loaded">
        <address-empty></address-empty>
      </div>
    </div>
    <div v-if="geolocationError" class="geolocationError">
      <i></i>
      <p>暂时无法获取自提门店信息，请开启您的地理位置信息。</p>
    </div>
  </div>
</template>

<script>
import addressItem from './item'
import addressEmpty from './empty'
import { Indicator } from 'mint-ui'
import http from '@/plugins/http'
import { getLocation } from '@/plugins/location'

export default {
  created() {},
  async mounted() {
    this.$$loading(false)
    try {
      const { citycode, lat, lng } = await getLocation()
      const params = {
        business_ids: this.pickUpPoint,
        kidStore: 1,
        lng,
        lat,
        citycode
      }
      await this.fetchAddressAll(params)
    } catch (err) {
      this.geolocationError = true
    }
  },
  data() {
    return {
      title: '自提地址',
      loaded: false,
      listWithoutKeywords: [],
      list: [],
      lastShowNum: 0,
      pageNum: 1,
      geolocationError: false,
      keywords: ''
    }
  },
  methods: {
    onInput() {
      if (this.keywords) {
        this.list = this.listWithoutKeywords.filter(item => {
          // return item.short_name.indexOf(this.keywords) != -1 || item.address.indexOf(this.keywords) != -1
          return item.short_name.indexOf(this.keywords) != -1
        })
      } else {
        this.list = this.listWithoutKeywords
      }
    },
    back() {},
    async fetchAddressAll(params) {
      const url = '//api.czj100.com/big.business/getBranchList' //门店
      //加载ing
      Indicator.open()
      let res = await http.get(url, params)
      //加载完毕
      Indicator.close()

      if (res.errno === 1024) {
        this.$$login()
      } else if (res.errno !== 0 && res.errno !== 401) {
        this.$$toast(res.errmsg)
      } else {
        if (res.data.length > 0) {
          this.list = res.data
          this.listWithoutKeywords = res.data
          this.lastShowNumFun()
        }
        this.loaded = true
      }
    },
    loadMore() {
      if (this.pageTotal >= this.pageNum) {
        this.pageNum++
        this.lastShowNumFun()
      }
    },
    lastShowNumFun() {
      this.lastShowNum = this.pageNum * 6
    },
    reloadList() {
      this.fetchAddressAll()
    },
    useAddress(item) {
      const json = JSON.stringify(item)
      sessionStorage.setItem('own/address.delivery', json)
      // 通知app
      const isCzj = this.$$isCZJApp()
      const fromCzjApp = this.$route.query.gofinish
      if ((isCzj || fromCzjApp) && !this.isPopup) {
        //数据转换
        let jsonApp = {
          store: item.short_name,
          address: item.address,
          phone: item.phone,
          startTime: item.start_time,
          endTime: item.end_time,
          objId: item.business_id
        }
        window.czjlocaljs.getCzjKeyValue('pickUpStore', JSON.stringify(jsonApp))
        try {
          window.localjs.gofinish()
        } catch (ex) {
          window.czjlocaljs.gofinish()
        }
      }

      if (this.isPopup) {
        this.$emit('useAddress', item)
      } else {
        this.$router.back()
      }
    }
  },
  props: {
    isPopup: {
      type: Boolean,
      default: false
    },
    selectedId: null,
    pickUpPoint: [String]
  },
  computed: {
    isAddMrg() {
      return !this.isPopup && !this.$$isCZJApp()
    },

    pageTotal() {
      return this.list.length > 0 ? Math.ceil(this.list.length / 6) : 0
    }
  },
  components: {
    addressItem,
    addressEmpty
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import '~assets/css/mixin.scss';

.container {
  position: relative;
  background: #fff;
  overflow-y: visible;
  &.u-pop {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    overflow-scrolling: touch;
  }
}
.list-wrap {
  .tj-ui {
    padding-left: rem(24px);
    height: rem(100px);
    line-height: rem(100px);
    font-size: rem(30px);
    color: #999999;
  }
  .keywords {
    margin: 0 0 rem(20px) rem(20px);
    padding: rem(5px) rem(15px);
    width: 50%;
    height: rem(60px);
    border-radius: rem(20px);
    background: #eeeeee;
    border: 0;
    outline: none;
  }
}

.empty {
  padding-top: rem(382px);
}
.footer {
  z-index: 3;
  position: fixed;
  /*position: absolute;*/
  /*height: rem(100px);*/
  bottom: 0;
  left: 0;
  right: 0;
  transform: translate3d(0, 0, 1px);
  background-image: linear-gradient(to right, #ff7d46, #ff4b4b);
  .btn {
    color: #fff;
    font-size: rem(36px);
    height: rem(100px);
    text-align: center;
    display: block;
    line-height: rem(100px);
    i {
      margin-right: rem(10px);
    }
  }
}
.geolocationError {
  display: flex;
  height: 100%;
  flex-direction: column;
  text-align: center;
  font-size: rem(28px);
  justify-content: center;
  i {
    display: block;
    width: 100%;
    height: rem(344px);
    background: url('~assets/images/order/icon_null_nolikeshop.png') no-repeat
      center;
    background-size: auto 100%;
  }
  p {
    line-height: 1.4;
  }
}
</style>
